// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__bM-BZ","content":"LayoutSettings_content__NL8pn"};